module.exports = __webpack_public_path__ + "europa-200_microprint.jpg?6f688a8a9cabc159d306e52745cd1ab7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-200_microprint.jpg
// module id = 322
// module chunks = 0